// Rotas internas que podem virar "documento do SGQ"
export const ROTAS_SISTEMA_SGQ = [
  {
    label: "Lista Mestra – SGQ",
    path: "/Lista-Mestra",
    tipos: ["admin"],
  },
  {
    label: "SGQ – Consulta",
    path: "/sgq",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Admin SGQ",
    path: "/admin-sgq",
    tipos: ["admin"],
  },
  {
    label: "Dashboard",
    path: "/dashboard",
    tipos: ["admin"],
  },
  {
    label: "Admin KPIs",
    path: "/admin/kpis",
    tipos: ["admin"],
  },
  {
    label: "Aprovações",
    path: "/app/aprovacoes",
    tipos: ["admin"],
  },
  {
  label: "Registro de Evento (NC)",
  path: "/app/ocorrencias",
  tipos: ["admin", "colaborador"],
  },
  {
    label: "Agenda de Moldagem e Ruptura",
    path: "/app/agendamoldagem",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Caracterização de Agregados",
    path: "/app/cadastro-caracterizacao",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Relatórios de Caracterização de Agregados",
    path: "/app/relatorios/caracterizacao",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Extrações de Testemunhos",
    path: "/app/extracoes-testemunhos",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Esclerometria",
    path: "/app/esclerometria",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Resistência de Aderência à Tração",
    path: "/app/resistencia-tracao",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Módulo de Elasticidade",
    path: "/app/modulo-elasticidade",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Relatórios de Módulo de Elasticidade",
    path: "/app/relatorios/modulo-elasticidade",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Ruptura de Paver",
    path: "/app/ruptura-paver",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Ruptura de Bloco Cerâmico",
    path: "/app/ruptura-bloco-ceramico",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Ruptura de Bloco de Concreto",
    path: "/app/ruptura-bloco-concreto",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Calibração de Prensa",
    path: "/app/calibracao-prensa",
    tipos: ["admin"],
  },
  {
    label: "Calibração Externa de Prensa",
    path: "/app/calibracao-prensa-externa",
    tipos: ["admin"],
  },
  {
    label: "Cadastro de Equipamentos",
    path: "/app/cadastro-equipamentos",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Controle de Temperatura dos Tanques",
    path: "/app/controle-temperatura-tanque-cura",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Gerar Etiquetas para Corpos de Prova",
    path: "/app/GerarEtiquetas",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Propostas Comerciais",
    path: "/app/proposta-comercial",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "RQ 7.1 — Cadastro e Qualificação de Fornecedores",
    path: "/app/qualificacao-fornecedores",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Fluxo de Caixa",
    path: "/app/caixinha-empresa",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Dosagens de Concreto",
    path: "/app/cadastro-dosagem",
    tipos: ["admin", "colaborador"],
  },


  {
    label: "Calibração de Prensa — Detalhes",
    path: "/app/calibracao-prensa/:id",
    tipos: ["admin"],
  },
  {
    label: "Calibração Externa de Prensa — Detalhes",
    path: "/app/calibracao-prensa-externa/:id",
    tipos: ["admin"],
  },
  {
    label: "Prensa SOLOS",
    path: "/app/calibracao-prensa-solos",
    tipos: ["admin"],
  },
  {
    label: "Calibração de Prensa de Solos — Detalhes",
    path: "/app/calibracao-prensa-solos/:id",
    tipos: ["admin"],
  },
  {
    label: "Ensaio RAA",
    path: "/app/ensaio-raa",
    tipos: ["cliente","colaborador","admin"],
  },
  {
    label: "Leituras RAA",
    path: "/app/ensaio-raa/:ensaioId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Extração",
    path: "/app/extracoes-testemunhos/:extracaoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Esclerometria",
    path: "/app/esclerometria/:esclerometriaId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Tração",
    path: "/app/resistencia-tracao/:tracaoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Argamassa - Tração e Compressão",
    path: "/app/ensaio-argamassa",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Argamassa",
    path: "/app/ensaio-argamassa/:argamassaId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Medições",
    path: "/app/medicoes",
    tipos: ["admin"],
  },
  {
    label: "Medição",
    path: "/app/medicoes/novo",
    tipos: ["admin"],
  },
  {
    label: "Medição",
    path: "/app/medicoes/:medicaoId",
    tipos: ["admin"],
  },
  {
    label: "Detalhes Ruptura Paver",
    path: "/app/ruptura-paver/:paverId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Ruptura Bloco Cerâmico",
    path: "/app/ruptura-bloco-ceramico/:blocoCeramicoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Ruptura de Bloco de Concreto",
    path: "/app/ruptura-bloco-concreto/:blocoConcretoId",
    tipos: ["admin", "colaborador"],
  },
  {
    label: "Ensaio Solo-Cimento",
    path: "/app/ensaio-solo-cimento",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Ruptura Tijolo Solo Cimento",
    path: "/app/ensaio-solo-cimento/:soloCimentoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Caracterização",
    path: "/app/cadastro-caracterizacao/:caracterizacaoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Caracterização Miúdo",
    path: "/app/cadastro-caracterizacao-miudo/:caracterizacaoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Consist. Cimento/Pega",
    path: "/app/cimento-consistencia-pega",
    tipos: ["cliente","colaborador","admin"],
  },
  {
    label: "Cadastro Cimento Pega",
    path: "/app/cimento-consistencia-pega/:ensaioId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Ensaio de Compactação",
    path: "/app/ensaio-compactacao",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Compactação",
    path: "/app/ensaio-compactacao/:compactacaoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Densidade IN SITU",
    path: "/app/densidade-in-situ",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Densidade In Situ",
    path: "/app/densidade-in-situ/:insituId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Cadastro Solicitação Serviços",
    path: "/app/solicitacao-servicos",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Proposta Comercial",
    path: "/app/proposta-comercial/:propostaId",
    tipos: ["admin"],
  },
  {
    label: "Locação de equipamentos",
    path: "/app/locacao-equipamentos",
    tipos: ["admin"],
  },
  {
    label: "Detalhes Locação Equipamentos",
    path: "/app/locacao-equipamentos/:locacaoId",
    tipos: ["admin"],
  },
  {
    label: "Detalhes Dosagem",
    path: "/app/cadastro-dosagem/:dosagemId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Gestão de mudanças",
    path: "/app/gestao-mudancas",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Detalhes Gestão Mudanças",
    path: "/app/gestao-mudancas/:registroId",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Verificação de Competências e Habilidades",
    path: "/app/verificacao-competencias",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Detalhes Verificação de Competências",
    path: "/app/verificacao-competencias/:registroId",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Lista de Presença em Treinamentos",
    path: "/app/listas-presenca-treinamentos",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Detalhes Lista de Presença",
    path: "/app/listas-presenca-treinamentos/:registroId",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Análise Crítica da Direção",
    path: "/app/analise-critica-direcao",
    tipos: ["admin","qualidade"],
  },
  {
    label: "RQ 1.4 — Planejamento Estratégico",
    path: "/app/planejamento-estrategico",
    tipos: ["admin","qualidade"],
  },
  {
    label: "MQ 01 — Manual da Qualidade",
    path: "/app/manual-qualidade",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Detalhes Análise Crítica Direção",
    path: "/app/analise-critica-direcao/:registroId",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Guias de Dosagem",
    path: "/app/guias-dosagem",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Relatórios visita técnica",
    path: "/app/relatorios-visita-tecnica",
    tipos: ["admin"],
  },
  {
    label: "Detalhes Visita Técnica",
    path: "/app/relatorios-visita-tecnica/:visitaTecnicaId",
    tipos: ["admin"],
  },
  {
    label: "Relatório Dosagem",
    path: "/app/relatorios/dosagem",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Adesividade ao Ligante",
    path: "/app/adesividade-ligante-betuminoso",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Caracterização Asfalto",
    path: "/app/caracterizacao-asfalto",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Caracterização Asfalto",
    path: "/app/caracterizacao-asfalto/:caracterizacaoAsfaltoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Traço CBUQ — Detalhes",
    path: "/app/traco-cbuq",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Traço CBUQ — Detalhes",
    path: "/app/traco-cbuq/:tracoId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Relatório do Traço CBUQ",
    path: "/app/traco-cbuq/:tracoId/relatorio",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Detalhes Adesividade",
    path: "/app/adesividade-ligante-betuminoso/:adesividadeId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Relatório Adesividade",
    path: "/app/relatorios/adesividade-ligante-betuminoso",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Agenda Ruptura",
    path: "/app/agendamoldagem/:moldagemId",
    tipos: ["admin","colaborador","qualidade","cliente"],
  },
  {
    label: "Rupturas do Dia",
    path: "/app/rupturas-hoje",
    tipos: ["admin","colaborador","qualidade"],
  },
  {
    label: "Perguntas do KPI",
    path: "/admin/kpis/:id/perguntas",
    tipos: ["admin"],
  },
  {
    label: "Pesquisas Respondidas",
    path: "/admin/kpis/respostas",
    tipos: ["admin"],
  },
  {
    label: "Admin Psicossocial Respostas",
    path: "/admin/psicossocial/respostas",
    tipos: ["admin"],
  },
  {
    label: "Cadastro Psicossocial",
    path: "/admin/psicossocial/cadastro",
    tipos: ["admin"],
  },
  {
    label: "Cadastro Equipamento Detalhes",
    path: "/app/cadastro-equipamento/:equipamentoId",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Registrar Ocorrências",
    path: "/kpi/evento/:kpiId",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Ocorrência Detalhe",
    path: "/ocorrencias/:eventoId",
    tipos: ["admin"],
  },
  {
    label: "Pesquisas",
    path: "/app/pesquisa",
    tipos: ["cliente","colaborador","admin"],
  },
  {
    label: "Responder Pesquisa",
    path: "/app/pesquisa/:kpiId",
    tipos: ["cliente","colaborador","admin"],
  },
  {
    label: "Usuários",
    path: "/app/cadastrousuarios",
    tipos: ["admin"],
  },
  {
    label: "Laudos",
    path: "/app/cadastrarlaudos",
    tipos: ["admin"],
  },
  {
    label: "Tabela de Cilindros",
    path: "/app/configuracoes/tabela-cilindros",
    tipos: ["admin"],
  },
  {
    label: "Logo do Sistema e Relatórios",
    path: "/app/configuracoes/logo-relatorios",
    tipos: ["admin"],
  },
  {
    label: "Tabela de Cápsulas",
    path: "/app/configuracoes/tabela-capsulas",
    tipos: ["admin"],
  },
  {
    label: "Faixas DNIT - Solos",
    path: "/app/configuracoes/faixas-dnit",
    tipos: ["admin"],
  },
  {
    label: "Faixas DNIT - Asfalto CBUQ",
    path: "/app/configuracoes/faixas-dnit-asfalto",
    tipos: ["admin"],
  },
  {
    label: "Novo Cadastro Materiais",
    path: "/app/NovoCadastroMateriais",
    tipos: ["admin"],
  },
  {
    label: "Cadastro Clientes",
    path: "/app/clientes",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Obras",
    path: "/app/cadastroobras",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Concreteiras",
    path: "/app/cadastro-concreteiras",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Plano de Comunicação",
    path: "/app/plano-comunicacao",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Objetivos da Qualidade",
    path: "/app/objetivos-qualidade",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Detalhes Objetivos da Qualidade",
    path: "/app/objetivos-qualidade/:cadastroId",
    tipos: ["admin","qualidade"],
  },
  {
    label: "RQ 1.6 — Matriz de Riscos",
    path: "/app/matriz-riscos",
    tipos: ["admin","qualidade"],
  },
  {
    label: "RQ 1.8 — Requisitos Legais",
    path: "/app/requisitos-legais",
    tipos: ["admin","qualidade"],
  },
  {
    label: "RQ 1.13 — Planejamento de Recursos",
    path: "/app/planejamento-recursos",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Detalhes do Planejamento de Recursos",
    path: "/app/planejamento-recursos/:registroId",
    tipos: ["admin","qualidade"],
  },
  {
    label: "RQ 10.2 — Volume e Controle de Resíduos",
    path: "/app/controle-residuos",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Programa de Treinamentos",
    path: "/app/programa-treinamentos",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Quadro de Competências",
    path: "/app/quadro-competencias",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Controle de Manutenção de Equipamentos",
    path: "/app/controle-manutencao-equipamentos",
    tipos: ["admin","qualidade"],
  },
  {
    label: "Departamento Pessoal",
    path: "/app/departamento-pessoal",
    tipos: ["admin","departamento_pessoal"],
  },
  {
    label: "Cadastro de Funcionário",
    path: "/cadastro-funcionario/:funcionarioId",
    tipos: ["admin","departamento_pessoal"],
  },
  {
    label: "Cadastro de Funcionário",
    path: "/app/departamento-pessoal/novo",
    tipos: ["admin","departamento_pessoal"],
  },
  {
    label: "Materiais",
    path: "/app/cadastromateriais",
    tipos: ["admin","colaborador"],
  },
  {
    label: "Consulta de Laudos",
    path: "/app/laudos",
    tipos: ["cliente"],
  },
];
